var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.processes,"label":_vm.$t(_vm.schema.name),"dense":"","filled":""},model:{value:(_vm.localeValue),callback:function ($$v) {_vm.localeValue=$$v},expression:"localeValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }